import React from "react";

export const DepartureCell = ({ checkOutDate }: { checkOutDate: Date }) => {
  return (
    <div className="text-sm text-center">
      <div>{new Date(checkOutDate).toLocaleDateString("en-GB")}</div>
      <div className="text-xs text-gray-500">
        {new Date(checkOutDate).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </div>
    </div>
  );
};
